import { GETALL_DEPOSIT_HEADER_REQUEST ,
    GETALL_DEPOSIT_HEADER_SUCCESS ,
    GETALL_DEPOSIT_HEADER_ERROR   , } from "../actions/types";
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GETALL_DEPOSIT_HEADER_REQUEST:
            return {
                loading: true,
            };
        case GETALL_DEPOSIT_HEADER_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GETALL_DEPOSIT_HEADER_ERROR:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
}
